import React, { useState, useEffect } from 'react'
import GridContainer from '../../Components/Grid/GridContainer'
import { makeStyles } from '@material-ui/core/styles';
import 'jquery-confirm';
import * as _ from 'lodash';
import { api } from 'axiosConfig';
import Label from './Label';
import Profiles from './Profiles';
import BasicProfile from './BasicProfile';
import Redemptions from './Redemptions';
import Referrals from './Referrals';
import Rewards from './Rewards';
import Surveys from './Surveys';
import Loading from './Loading';
import TopHeading from './TopHeading';

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(4),
        fontSize: '16px',
        textAlign: 'center'
    },
}));

export default function PenalistDetails(props: any) {

    const [penalistData, setPenalistData] = useState<any>([]);
    const [profileData, setProfileData] = useState<any>([]);
    const [profileOverviewData, setProfileOverviewData] = useState<any>(null);
    const [error, setError] = useState<any>(false);
    const [userID, setUserID] = useState<string>('');
    const classes = useStyles();

    useEffect(async () => {
        const { userId } = props.match.params;
        setUserID(userId);
        const url = process.env.REACT_APP_BASE_URL_API + '/api/v1/auth/user/panelistProfile/' + userId;
        await api.post(url, {})
            .then((res) => {
                setPenalistData(_.get(res, 'data', {}));
            })
            .catch((err) => {
                setError(true);
                console.log(err);
            });

        const url2 = process.env.REACT_APP_BASE_URL_API + '/api/v1/auth/user/get-user/' + userId;
        await api.post(url2, {})
            .then((res) => {
                setProfileData(_.get(res, 'data', {}));
            })
            .catch((err) => {
                setError(true);
                console.log(err);
            });

        const url3 = process.env.REACT_APP_BASE_URL_API + '/api/v1/auth/user/respondentProfileOverview/' + userId;
        await api.post(url3, {})
            .then((res) => {
                setProfileOverviewData(_.get(res, 'data.data', {}));
            })
            .catch((err) => {
                setError(true);
                console.log(err);
            });
    }, []);

    if (!penalistData.hasOwnProperty('data') || penalistData.data === null) return <>
        <TopHeading />
        <div className='text-center'>No Penalist Found</div>
    </>;
    return (
        <GridContainer>
            {penalistData.length !== 0 ?
                <TopHeading userID={userID} setProfileData={setProfileData} setError={setError} profileData={profileData} />
                : null}
            {
                penalistData.length === 0 && profileData.length === 0 ? <Loading error={error} /> :
                    <React.Fragment>
                        <BasicProfile profileData={profileData} />
                        <Label />
                        {profileOverviewData ?
                            <Profiles penalistData={penalistData} profileOverviewData={profileOverviewData} /> : ''}
                        <Surveys penalistData={penalistData} classes={classes} />
                        <Rewards penalistData={penalistData} classes={classes} />
                        <Referrals penalistData={penalistData} classes={classes} />
                        <Redemptions penalistData={penalistData} classes={classes} />
                    </React.Fragment>
            }

        </GridContainer>
    )
}
